import { createCrmEnrichmentQueryKeys } from "app/pages/sales-intelligence/modules/crm-enrichment/query/key-factory/factory";

export const dynamicsEnrichmentQueryKeys = createCrmEnrichmentQueryKeys("dynamics");
